var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSecondAttemptIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.38574 10.6402H10.438V11.605H5.87354V10.7979L8.51758 8.08426C8.9598 7.62967 9.18091 7.19673 9.18091 6.78543C9.18091 6.46691 9.08659 6.21951 8.89795 6.04324C8.70931 5.86388 8.45418 5.7742 8.13257 5.7742C7.79549 5.7742 7.52954 5.87316 7.33472 6.07108C7.13989 6.2659 7.04248 6.57824 7.04248 7.00809V7.49515L5.98022 7.3931V7.022C5.98022 6.33548 6.1735 5.80822 6.56006 5.44022C6.94661 5.07221 7.46924 4.88821 8.12793 4.88821C8.74642 4.88821 9.25203 5.05675 9.64478 5.39383C10.0375 5.73091 10.2339 6.19323 10.2339 6.78079C10.2339 7.11787 10.1612 7.42866 10.0159 7.71317C9.87052 7.99767 9.64168 8.30228 9.32935 8.62698L7.38574 10.6402Z",
  fill: "#929BBB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M8 0.616272C3.584 0.616272 0 4.20027 0 8.61627C0 13.0323 3.584 16.6163 8 16.6163C12.416 16.6163 16 13.0323 16 8.61627C16 4.20027 12.416 0.616272 8 0.616272ZM8 15.0163C4.472 15.0163 1.6 12.1443 1.6 8.61627C1.6 5.08827 4.472 2.21627 8 2.21627C11.528 2.21627 14.4 5.08827 14.4 8.61627C14.4 12.1443 11.528 15.0163 8 15.0163Z",
  fill: "#31417A",
  fillOpacity: 0.7
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSecondAttemptIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/secondAttemptIcon.4da7946b4bf4116e14139c10a09e2493.svg";